module.exports = __webpack_public_path__ + "img/bj_10.04d8bc15.jpg";